import { PaymentControllerApi } from 'api/base/api.ts'
import { configuration } from 'api/utils/apiConfiguration.ts'
import { customFetch } from 'api/utils/customFetch.ts'

class PaymentConfirmApi {
  api = new PaymentControllerApi(configuration, configuration.basePath, customFetch)

  confirmPayment = (paymentIntentId: string) => this.api.confirmPayment(paymentIntentId)

}

export const paymentConfirmApi = new PaymentConfirmApi()